import mAxios from './m-axios'
import { User } from './user'

export interface Org {
  org_id: string
  name: string
  image?: string
  desc?: string
  owner_id?: string
  owner?: User
}

export const newOrg = (): Org => ({
  org_id: '',
  name: '',
  desc: '',
})

export interface Module {
  id: number
  name: string
  key?: number
  desc: string
  image: string
  grades: Grade[]
  type: string
}

export const newOrgType = (): Module => ({
  id: 0,
  name: '',
  desc: '',
  image: '',
  grades: [],
  type: '',
})

export interface Grade {
  id: number
  key?: number
  sort?: number
  name?: string
  desc?: string
  module?: Module
  lesson_groups?: {
    0?: number[]
    1?: number[]
    2?: number[]
    3?: number[]
  }
}

export const listModule = (ids: number[]) => {
  let params = { ids: '', all: false, type: 'course' }
  if (ids.length > 0) {
    params.ids = JSON.stringify(ids)
  } else {
    params.all = true
  }

  return mAxios({
    method: 'get',
    url: '/api/module',
    params: params,
  }).then(res => res.data)
}

export const updateOrg = (org: Org) => {
  return mAxios({
    method: 'put',
    url: '/api/org',
    data: org,
  }).then(res => res.data)
}

export const listUser = (org_id: string) => {
  return mAxios({
    method: 'get',
    url: '/api/user',
    params: {
      org_id: org_id,
    },
  }).then(res => res.data)
}
